import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-83221dfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "delete-task-modal__message" }, " Are you sure you want to delete this task? ", -1))
const _hoisted_2 = { class: "delete-task-modal__warning" }

import { ref } from 'vue';
import type { Ref } from 'vue';

import TaskInterface from '@/interfaces/Task.interface';

import DSModal from '@/design-system/DSModal.vue';
import DSBadge from '@/design-system/DSBadge.vue';

import { useStore } from '@/store';
import formatTimer from '@/hooks/formatTimer';
import { DELETE_TASK } from '@/store/types/actions';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteTaskModal',
  setup(__props, { expose: __expose }) {

const store = useStore();
const task: Ref<TaskInterface> = ref({} as TaskInterface);
const show_modal = ref(false);
const request_pending = ref(false);

const getTaskTime = () => {
  return task.value.total_time_spent || task.value.time_spent || 0;
};

const deleteTask = async () => {
  request_pending.value = true;
  await store.dispatch(DELETE_TASK, task.value);
  closeModal();
  return request_pending.value = false;
};

const closeModal = () => {
  show_modal.value = false;
};

const openModal = (state_task: TaskInterface) => {
  show_modal.value = true;
  task.value = state_task;
};

__expose({
  closeModal,
  openModal,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DSModal, {
    modelValue: show_modal.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((show_modal).value = $event)),
    title: "Delete Task",
    loading: request_pending.value,
    "confirm-label": "Delete",
    variant: "danger",
    onConfirm: deleteTask,
    onCancel: closeModal
  }, {
    body: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("p", _hoisted_2, [
        _createTextVNode(" You have already spent "),
        _createVNode(DSBadge, {
          label: _unref(formatTimer)(getTaskTime()),
          variant: "danger"
        }, null, 8, ["label"]),
        _createTextVNode(" of total time. This progress cannot be recovered. ")
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "loading"]))
}
}

})